export const LIST_COLUMN = [
    {
        prop: 'userName',
        label: '员工姓名',
    },
    {
        prop: 'userCode',
        label: '员工账号',
    },
    {
        prop: 'contact',
        label: '其他联系方式',
    },
    {
        prop: 'status',
        label: '状态',
    },
    {
        prop: 'operation',
        label: '操作'   
    }
]
